// extracted by css-extract-rspack-plugin
export default {"container":"IssueTypeIndicator-module__container__GQNBe"};